import { MessageService } from './../../../core/services/message.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Account } from 'src/app/model/account';
import { DateAdapter } from '@angular/material/core';
import { MatSelectChange } from '@angular/material/select';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertDialogComponent } from 'src/app/store/dialogs/alert-dialog/alert-dialog.component';
import { ModelService } from 'src/app/core/services/model.service';
import { LoginService } from 'src/app/core/services/login.service';
import { FormControl, Validators } from '@angular/forms';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { AccountRole } from 'src/app/model/account-role';
import { MatDialog } from '@angular/material/dialog';
import { RolesService } from 'src/app/core/services/roles.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import * as _ from 'lodash';
import { CustomerService } from '../../../core/services/customer.service';
import { TbAuthService } from '@tb/auth';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { AccountService } from 'src/app/core/services/account.service';
import { AccountHomeInfo } from 'src/app/model/account-home';
import { RolesWeight } from 'src/app/authentication/auth-helpers';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { MatDatepicker } from '@angular/material/datepicker';

@Component({
    selector: 'tb-account-create-account',
    templateUrl: './account-create-account.component.html',
    styleUrls: ['./account-create-account.component.scss'],
})
export class AccountCreateAccountComponent implements OnInit {
    new = false;
    model: Account;
    copyOfModel: Account;
    saving: boolean;
    accountName: string;
    readingData: boolean;
    accountRoles: Array<AccountRole>;
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    readOnly: boolean = true;
    internalRoles: boolean;
    accountnameControl: FormControl;
    fullnameControl: FormControl;
    emailControl: FormControl;
    verifyEmailControl: FormControl;
    // nicknameControl: FormControl;
    // errorNickName: boolean = false;
    // previousValue: string;
    today = new Date();
    minDate = new Date();
    showComponent = false;
    languageOfTheUser: string;
    regionalSettingsOfTheUser: string;
    isDevOpsOrHigher = false;
    @Output() saved = new EventEmitter<string>();

    languages: Array<{ name: string; value: string }> = [
        { name: 'Italian', value: 'it-IT' },
        // { name: 'English', value: 'en-EN' },
        { name: 'English', value: 'en' },
        { name: 'Bulgarian', value: 'bg-BG' },
        { name: 'Hungarian', value: 'hu-HU' },
        { name: 'Romanian', value: 'ro-RO' },
        { name: 'Portuguese (Brazil)', value: 'pt-BR' },
        { name: 'Italian (Switzerland)', value: 'it-CH' },
        { name: 'Polish', value: 'pl-PL' },
        { name: 'Spanish', value: 'es-ES' },
        { name: 'Spanish (Chile)', value: 'es-CL' },
        { name: 'Slovenian', value: 'sl-SI' },
        { name: 'German', value: 'de-DE' },
        { name: 'German (Switzerland)', value: 'de-CH' },
        { name: 'French', value: 'fr-FR' },
        { name: 'Greek', value: 'el-GR' },
        { name: 'Turkish', value: 'tr-TR' },
        { name: 'Russian', value: 'ru-RU' },
        { name: 'Croatian', value: 'hr-HR' },
    ];

    selectedLanguage: { name: string; value: string } = { name: '', value: '' };

    regionalSettings: Array<{ name: string; value: string }> = [
        { name: 'Italian', value: 'it-IT' },
        // { name: 'English', value: 'en-EN' },
        { name: 'English', value: 'en' },
        { name: 'Bulgarian', value: 'bg-BG' },
        { name: 'Hungarian', value: 'hu-HU' },
        { name: 'Romanian', value: 'ro-RO' },
        { name: 'Portuguese (Brazil)', value: 'pt-BR' },
        { name: 'Italian (Switzerland)', value: 'it-CH' },
        { name: 'Polish', value: 'pl-PL' },
        { name: 'Spanish', value: 'es-ES' },
        { name: 'Spanish (Chile)', value: 'es-CL' },
        { name: 'Slovenian', value: 'sl-SI' },
        { name: 'German', value: 'de-DE' },
        { name: 'German (Switzerland)', value: 'de-CH' },
        { name: 'French', value: 'fr-FR' },
        { name: 'Greek', value: 'el-GR' },
        { name: 'Turkish', value: 'tr-TR' },
        { name: 'Russian', value: 'ru-RU' },
        { name: 'Croatian', value: 'hr-HR' },
    ];

    selectedRs: { name: string; value: string } = { name: '', value: '' };

    constructor(
        private modelService: ModelService,
        private loginService: LoginService,
        private router: Router,
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private rolesService: RolesService,
        public workflow: WorkFlowService,
        public customerService: CustomerService,
        public configurationService: ConfigurationService,
        private accountService: AccountService,
        private authService: TbAuthService,
        private adapter: DateAdapter<any>,
        private variable: TranslatedVariables
    ) {
        if (this.authService.isSessionStorage()) {
            this.languageOfTheUser = sessionStorage.getItem('M4_ui_culture');
            this.regionalSettingsOfTheUser = sessionStorage.getItem('M4_culture');
        } else {
            this.languageOfTheUser = localStorage.getItem('M4_ui_culture');
            this.regionalSettingsOfTheUser = localStorage.getItem('M4_culture');
        }
        this.minDate.setDate(this.today.getDate() + 1);
        this.model = new Account();
        this.copyOfModel = new Account();
        this.accountnameControl = new FormControl(this.model.AccountName, Validators.required);
        this.fullnameControl = new FormControl(this.model.FullName, [Validators.required, Validators.minLength(4)]);
        this.emailControl = new FormControl(this.model.Email, [Validators.required, Validators.email]);
        this.verifyEmailControl = new FormControl('', [Validators.required, Validators.email]);
        // this.nicknameControl = new FormControl();
        // valorizzo il provider come GWAM perchè sto salvando l'utente dal front end del provisioning
        this.model.AuthenticationProvider = 'gwam';
        this.copyOfModel.AuthenticationProvider = 'gwam';
        this.saving = false;
        this.readingData = false;
        this.accountRoles = new Array<AccountRole>();
    }

    ngOnInit() {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);

        if (this.authorizationStored === null) {
            this.workflow.showMessage(this.variable.warningTitle, this.variable.mustBeLogged);
            return;
        }

        this.isDevOpsOrHigher = this.rolesService.checkRolesMin(RolesWeight.DEVOPS);

        this.getLanguages(this.authorizationProperties.accountName);

        this.isReadOnly();

        this.route.queryParams.subscribe((params) => {
            this.accountName = params.accountName;
        });

        let canCreateAccount = this.rolesService.checkRolesMin(RolesWeight.COUSERADMIN);
        if (canCreateAccount) {
            if (this.accountName === undefined) {
                this.showComponent = true;
                this.new = true;
                let d = new Date();
                d.setDate(d.getDate() + 90);
                this.model.PasswordExpirationDate = d;
                this.model.ParentAccount = this.authorizationProperties.accountName;
                this.model.LoginFailedCount = 0;
                this.model.Confirmed = false;
                this.copyOfModel.PasswordExpirationDate = d;
                this.copyOfModel.ParentAccount = this.authorizationProperties.accountName;
                this.copyOfModel.LoginFailedCount = 0;
                this.copyOfModel.Confirmed = false;
                // this.nicknameControl.disable();
                this.setDatePickerFormat(false);
            } else {
                this.modelService.getAccountHomeInfo(this.authorizationProperties.accountName).subscribe(
                    (res) => {
                        if (!res.Result) {
                            this.readingData = false;
                            return;
                        }
                        const listAccountName: AccountHomeInfo[] = res['Content'].filter(
                            (x) => x.IsEditable && x.AccountName !== this.authorizationProperties.accountName
                        );
                        if (listAccountName.some((x) => x.AccountName === this.accountName) || this.isDevOpsOrHigher) {
                            this.showComponent = true;
                            this.update();
                            this.readingData = false;
                            return;
                        } else {
                            // old, da controllare
                            return;
                        }
                    },
                    (err) => {
                        this.workflow.showMessage(this.variable.errorTitle, err.message);
                        this.readingData = false;
                    }
                );
            }
        } else {
            const dlgAsk = this.dialog.open(AlertDialogComponent, {
                data: {
                    Title: this.variable.account,
                    Message: this.variable.permissionDenied,
                },
            });
            dlgAsk.afterClosed().subscribe((resAskDlg) => {
                if (resAskDlg === undefined) {
                    this.router.navigate(['/ShoppingCompact']);
                }
            });
            this.readingData = false;
            return;
        }
    }

    // ---------------------------------------------------------------------------
    update() {
        this.loginService.getAccountIfExistsBy(this.accountName).subscribe((res) => {
            const opRes: boolean = res['Result'];
            if (!opRes) {
                this.workflow.showMessage(this.variable.warningTitle, res['Message']);
                return;
            }
            const account: Account = res['Content'];

            if (!account) {
                return;
            }

            // for each field I have to assign each value!
            this.model.assign(account);
            this.copyOfModel.assign(account);
            this.accountnameControl.setValue(this.model.AccountName);
            this.fullnameControl.setValue(this.model.FullName);
            this.emailControl.setValue(this.model.Email);
            // this.nicknameControl.setValue(this.model.NickName);
            this.isChanged(this.model.FullName, 'FullName'); // enable the nicknameControl if there is a FullName

            this.selectedLanguage = this.languages.find((l) => l.value === this.model.Language);
            this.selectedRs = this.regionalSettings.find((rs) => rs.value === this.model.RegionalSettings);
            this.setDatePickerFormat(true);
        });
    }

    copyText(inputElement) {
        inputElement.select();
        document.execCommand('copy');
    }

    selectedRsChange(selectedValue: MatSelectChange) {
        if (selectedValue === undefined) {
            return;
        }
        this.model.RegionalSettings = selectedValue.value.value;
    }

    selectedLanguageChange(selectedValue: MatSelectChange) {
        if (selectedValue === undefined) {
            return;
        }
        this.model.Language = selectedValue.value.value;
    }

    changeLock() {
        if (this.model.Locked) {
            this.model.LoginFailedCount = 5;
        } else {
            this.model.LoginFailedCount = 0;
        }
    }

    saveAccount() {
        // now I save the account
        this.model.AccountName = this.accountnameControl.value;
        this.model.FullName = this.fullnameControl.value;
        this.model.Email = this.emailControl.value;
        // this.model.NickName = this.nicknameControl.value;
        if (!this.model.Language) {
            this.model.Language = this.languageOfTheUser;
        }
        if (!this.model.RegionalSettings) {
            this.model.RegionalSettings = this.regionalSettingsOfTheUser;
        }
        const accountOperation = this.accountService.saveAccount(this.model, this.authorizationProperties.accountName).subscribe(
            (accountResult) => {
                if (!accountResult.Result) {
                    this.saving = false;
                    this.saved.emit();
                    switch (accountResult.Code) {
                        case 42:
                            this.workflow.showMessage(this.variable.warningTitle, this.variable.accAlreadyExists);
                            break;
                        default:
                            this.workflow.showMessage(this.variable.errorSaving, accountResult.Message);
                    }
                    accountOperation.unsubscribe();
                    return;
                }
                this.copyOfModel.assign(this.model);
                accountOperation.unsubscribe();
                this.saving = false;
                this.workflow.showSnackBar(this.variable.operationSucceeded, this.variable.snackBarSubTitle);
                this.saved.emit(this.model.AccountName);
            },
            (err) => {
                this.saving = false;
                var errMess = err.statusText;
                var det = err.error == undefined ? '' : err.error.Message == undefined ? '' : err.error.Message;
                this.workflow.showMessage(this.variable.errorSaving, errMess + det);
                accountOperation.unsubscribe();
                this.saved.emit();
            }
        );
    }

    isReadOnly() {
        this.accountRoles = this.authorizationProperties.roles as AccountRole[];
        this.internalRoles = this.rolesService.checkRolesMin(RolesWeight.INTERNAL);
        if (this.accountRoles.some((x) => x.AccountName === this.authorizationProperties.accountName && this.internalRoles)) {
            this.readOnly = false;
        }
    }

    getLanguages(accountName: string) {
        const getLanguages = this.modelService.getLanguages(accountName).subscribe(
            (res) => {
                const opRes: boolean = res['Result'];
                if (!opRes) {
                    return;
                }
                getLanguages.unsubscribe();
            },
            (err) => {
                this.workflow.showMessage(this.variable.errorTitle, err.message);
                getLanguages.unsubscribe();
            }
        );
    }

    amICreating() {
        if (this.accountName) {
            return true;
        } else {
            return false;
        }
    }

    isChanged(newValue: any, field: string) {
        this.model[field] = newValue;
        // controllo se i dati sono stati modificati e se i campi obbligatori ci sono per permettere il salvataggio
        switch (field) {
            case 'FullName':
                if (
                    this.isSomethingChanged() &&
                    this.accountnameControl.valid &&
                    this.fullnameControl.valid &&
                    this.emailControl.valid &&
                    this.verifyEmailControl.valid &&
                    this.emailControl.value === this.verifyEmailControl.value
                    // && !this.errorNickName
                ) {
                    this.saving = true;
                } else {
                    this.saving = false;
                }
            // if (
            //     newValue.replace(/\s/g, "") &&
            //     newValue.replace(/\s/g, "").length >= 4
            // ) {
            //     this.previousValue = this.nicknameControl.value;
            //     this.nicknameControl.enable();
            //     return;
            // } else if (
            //     !newValue.replace(/\s/g, "") ||
            //     newValue.replace(/\s/g, "").length < 4
            // ) {
            //     this.previousValue = this.nicknameControl.value;
            //     this.nicknameControl.disable();
            //     return;
            // }
            default:
                // if (field === "MustChangePassword" && this.model.MustChangePassword) {
                //     this.model.CannotChangePassword = false;
                // }
                // if (field === "CannotChangePassword" && this.model.CannotChangePassword) {
                //     this.model.MustChangePassword = false;
                // }
                // if (field === "NickName" && newValue === "") {
                //     this.errorNickName = false;
                //     if (this.copyOfModel.NickName === null) {
                //         this.copyOfModel.NickName = "";
                //     }
                // }
                if (
                    this.isSomethingChanged() &&
                    this.accountnameControl.valid &&
                    this.fullnameControl.valid &&
                    this.emailControl.valid &&
                    this.verifyEmailControl.valid &&
                    this.emailControl.value === this.verifyEmailControl.value
                    // && !this.errorNickName
                ) {
                    this.saving = true;
                } else {
                    this.saving = false;
                }
        }
    }

    getErrorMessage() {
        return this.accountnameControl.hasError('required') ? this.variable.commonsEmpty : '';
    }

    getEmailErrorMessage() {
        return this.emailControl.hasError('required')
            ? this.variable.commonsEmpty
            : this.emailControl.hasError('email')
            ? this.variable.commonsEmailNotValid
            : this.verifyEmailControl.hasError('required')
            ? this.variable.commonsEmpty
            : this.verifyEmailControl.hasError('email')
            ? this.variable.commonsEmailNotValid
            : '';
    }

    getFullNameErrorMessage() {
        return this.fullnameControl.hasError('required')
            ? this.variable.commonsEmpty
            : this.fullnameControl.hasError('minlength')
            ? this.variable.commonsMinLength
            : '';
    }

    pDateValueChange(selectedValue: MatDatepicker<any>) {
        if (!selectedValue.datepickerInput.getStartValue()) {
            return;
        }
        // Nel caso si voglia inserire i dati nel database con l'ora italiana
        this.model.PasswordExpirationDate = this.setDate(selectedValue.datepickerInput.getStartValue());
        // let a = selectedValue.toLocaleString('it-IT', { timeZone: 'Europe/Rome' });
        // this.model.PasswordExpirationDate = selectedValue.datepickerInput.getStartValue();
        this.isChanged(this.model.PasswordExpirationDate, 'PasswordExpirationDate');
    }

    eDateValueChange(selectedValue: MatDatepicker<any>) {
        if (!selectedValue.datepickerInput.getStartValue()) {
            return;
        }
        // Nel caso si voglia inserire i dati nel database con l'ora italiana
        this.model.ExpirationDate = this.setDate(selectedValue.datepickerInput.getStartValue());
        // let a = selectedValue.toLocaleString('it-IT', { timeZone: 'Europe/Rome' });
        // this.model.ExpirationDate = selectedValue.datepickerInput.getStartValue();
        this.isChanged(this.model.ExpirationDate, 'ExpirationDate');
    }

    setDate(value: Date) {
        let d = new Date();
        let h = d.getHours();
        let m = d.getMinutes();
        let s = d.getSeconds();
        value.setHours(h);
        value.setMinutes(m);
        value.setSeconds(s);

        return value;
    }
    setDatePickerFormat(hasRegionalSettings: boolean) {
        if (!hasRegionalSettings) {
            this.adapter.setLocale(navigator.language);
        } else {
            this.adapter.setLocale(this.model.RegionalSettings);
        }
    }
    isSomethingChanged() {
        let formField = [
            'AccountName',
            'FullName',
            'Email',
            'VerifyEmail',
            'NickName',
            'ExpirationDate',
            'PasswordExpirationDate',
            'RegionalSettings',
            'Language',
            'Notes',
            'PasswordNeverExpires',
            'MustChangePassword',
            'CannotChangePassword',
            'Disabled',
            'Locked',
            'MobilePhonePrefix',
            'MobilePhoneNr',
            'PrivateNotes',
            'PasswordDuration',
        ];

        let isFormChanged: boolean;
        for (let i = 0; i < formField.length; i++) {
            if (
                (formField[i] === 'RegionalSettings' || formField[i] === 'Language') &&
                typeof this.model[formField[i]] === 'object' &&
                this.model[formField[i]].value !== this.copyOfModel[formField[i]]
            ) {
                isFormChanged = true;
                return isFormChanged;
            } else if (typeof this.model[formField[i]] === 'string' && this.model[formField[i]] !== this.copyOfModel[formField[i]]) {
                isFormChanged = true;
                return isFormChanged;
            } else if (typeof this.model[formField[i]] === 'boolean' && this.model[formField[i]] !== this.copyOfModel[formField[i]]) {
                isFormChanged = true;
                return isFormChanged;
            } else if (
                (formField[i] === 'ExpirationDate' || formField[i] === 'PasswordExpirationDate') &&
                typeof this.model[formField[i]] === 'object'
            ) {
                this.copyOfModel[formField[i]] = new Date(this.copyOfModel[formField[i]]);
                if (
                    this.copyOfModel[formField[i]].getFullYear() !== this.model[formField[i]].getFullYear() ||
                    this.copyOfModel[formField[i]].getDate() !== this.model[formField[i]].getDate() ||
                    this.copyOfModel[formField[i]].getMonth() !== this.model[formField[i]].getMonth()
                ) {
                    isFormChanged = true;
                    return isFormChanged;
                }
            } else if (
                formField[i] !== 'RegionalSettings' &&
                formField[i] !== 'Language' &&
                formField[i] === 'ExpirationDate' &&
                formField[i] === 'PasswordExpirationDate' &&
                this.model[formField[i]] !== this.copyOfModel[formField[i]]
            ) {
                isFormChanged = true;
                return isFormChanged;
            } else {
                isFormChanged = false;
            }
        }
        return isFormChanged;
    }

    nothingHasChanged() {
        if (
            !this.accountnameControl.value &&
            !this.fullnameControl.value &&
            !this.emailControl.value &&
            !this.verifyEmailControl.value &&
            !this.model.ExpirationDate &&
            !this.model.Disabled &&
            !this.model.RegionalSettings &&
            !this.model.Language &&
            // !this.nicknameControl.value &&
            !this.model.Notes &&
            !this.model.Disabled &&
            !this.model.Locked &&
            !this.model.MustChangePassword &&
            !this.model.PasswordNeverExpires &&
            !this.model.CannotChangePassword
        ) {
            return true;
        }
        return false;
    }

    cancel() {
        this.copyOfModel.ExpirationDate = undefined;
        this.model.assign(this.copyOfModel);
        this.accountnameControl = new FormControl(this.model.AccountName, Validators.required);
        this.fullnameControl = new FormControl(this.model.FullName, [Validators.required, Validators.minLength(4)]);
        this.emailControl = new FormControl(this.model.Email, [Validators.required, Validators.email]);
        this.verifyEmailControl = new FormControl('', [Validators.required, Validators.email]);
        // this.nicknameControl = new FormControl();
        this.selectedLanguage = this.languages.find((l) => l.value === this.copyOfModel.Language);
        this.selectedRs = this.regionalSettings.find((rs) => rs.value === this.copyOfModel.RegionalSettings);
        this.saving = false;
    }
}
